export const anyAsync = async (source, predicate) => {
    for (const item of source) {
        if (await predicate(item) === true) {
            return true;
        }
    }
    return false;
};
